import React, { useState, useEffect } from 'react';
import { InputNumber } from 'antd';
import Modal from '../../../../_components/Modal';
import Button from '../../../../_components/Button';

export default function EditProductQuantityModal(props) {
    const [item, setItem] = useState(props.item);

    useEffect(() => {
        setItem(props.item);
    }, [props.item]);

    function onSave() {
        if (props.onHide) {
            props.onHide();
        }
        if (props.onSave) {
            props.onSave(item);
        }
    }
    function onChange(e){
        let tempData = item
        tempData.quantity = e
        setItem({...tempData})
    }
    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            title="Editar quantidade"
        >
            <InputNumber
                value={item.quantity}
                onChange={(e) => onChange(e)}
            />
            <Button onClick={onSave}>Alterar quantidade</Button>
        </Modal>
    );
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Purchases/createPurchase/editProductQuantityModal.jsx